import { LatLng } from "../../types/LatLng";
import { CENTER_OF_NORWAY } from "../map/defaults";

export const posParser = (params: { lat: string; lng: string; zoom?: string }): LatLng & { zoom: number } => ({
	lat: Number.parseFloat(params.lat ?? String(CENTER_OF_NORWAY.position.lat)),
	lng: Number.parseFloat(params.lng ?? String(CENTER_OF_NORWAY.position.lng)),
	zoom: Number.parseFloat(params?.zoom ?? String(CENTER_OF_NORWAY.zoom))
});
